import { render, staticRenderFns } from "./HospitalSpecialities.vue?vue&type=template&id=a8af8d3c"
import script from "./HospitalSpecialities.vue?vue&type=script&lang=js"
export * from "./HospitalSpecialities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports